import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import './Projects.css';
import { projects } from '../config';

function ProjectCard({ project, index }) {
  return (
    <motion.div
      className="project-card"
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-40px' }}
      transition={{ duration: 0.6, delay: index * 0.1, ease: [0.16, 1, 0.3, 1] }}
    >
      <div className="project-preview">
        <span>{project.title}</span>
        <div className="project-arrow">
          <svg width="24" height="24" viewBox="0 0 14 14" fill="none">
            <path d="M1 13L13 1M13 1H3M13 1V11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
      </div>
      <div className="project-body">
        <h3 className="project-title">{project.title}</h3>
        <p className="project-desc">{project.description}</p>
        <div className="project-footer">
          <div className="project-tags">
            {project.tags.map((t, i) => <span key={i}>{t}</span>)}
          </div>
          <a href={project.liveLink} target="_blank" rel="noopener noreferrer" className="project-link">View</a>
        </div>
      </div>
    </motion.div>
  );
}

const Projects = () => {
  const ref = useRef(null);
  const show = useInView(ref, { once: true, margin: '-80px' });

  return (
    <section id="projects" className="projects" ref={ref}>
      <div className="container">
        <motion.div className="section-label" initial={{ opacity: 0, y: 10 }} animate={show ? { opacity: 1, y: 0 } : {}} transition={{ duration: 0.5 }}>
          <span>Projects</span>
        </motion.div>

        <motion.h2 className="section-heading" initial={{ opacity: 0, y: 20 }} animate={show ? { opacity: 1, y: 0 } : {}} transition={{ duration: 0.5, delay: 0.05 }}>
          My Work
        </motion.h2>

        <div className="projects-grid">
          {projects.map((p, i) => <ProjectCard key={p.id} project={p} index={i} />)}
        </div>
      </div>
    </section>
  );
};

export default Projects;
